import { down, up } from "styled-breakpoints";
import styled from "styled-components";

export const Wrapper = styled.div`
  background: transparent;
  padding: 0;
  width: 100%;
  max-width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;

  form {
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration {
            -webkit-appearance: none;
            appearance: none;
  }

  input[type="search"]::-moz-search-cancel-button {
            -moz-appearance: none;
            appearance: none;
  }

  input[type="search"]::-ms-clear {
            display: none;
  }
  }

  .support-menu {
    position: fixed;
    bottom: 10%;
    right: 50px;
    z-index: 10000;
  }

  .support-menu .support {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background: var(--color-primary);
    border: none;
    outline: none;
    padding: 0px;

    &:hover {
      background: var(--color-primary-dark);
    }

    svg {
      width: 33.75px;
      height: 33.75px;

      path {
        strokeWidth: 2px;
      }
    }
  }

  ${down("md")} {
    .support-menu {
      right: 30px;
    }
  }

  nav.navbar {
          position: relative;
          background: #2b2b2b !important;
          /* box-shadow: 2px 3px 9px 4px #eaeaea; */
          padding: 1rem 0.9rem;
          border-radius: 0;

          ${up("md")} {
                    padding-left: 5%;
                    padding-right: 5%;
                    margin-left: auto;
                    margin-right: auto;
          }

          .menu_links {
                    ${up("md")} {
                            display: none;
                    }

                    display: block;
                    position: absolute;
                    background-color: #f1f1f1e5;
                    height: 200px;
                    z-index: -1;
                    top: 120%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100%;
                    border-radius: 12px;
                    padding: 1rem;
                    max-height: 50vh;
                    overflow: auto;

                    ul {
                            & > :not([hidden]) ~ :not([hidden]) {
                                      --tw-divide-y-reverse: 0;
                                      border-top-width: calc(
                                              1px *
                                                        calc(
                                                                1 -
                                                                          var(
                                                                                  --tw-divide-y-reverse
                                                                          )
                                                        )
                                      );
                                      border-bottom-width: calc(
                                              1px *
                                                        var(
                                                                --tw-divide-y-reverse
                                                        )
                                      );
                                      border-color: #cac8c8;
                            }

                            li {
                                      padding: 8px 0px;

                                      .nav_link,
                                      a {
                                              display: flex;
                                              align-items: center;
                                              justify-content: space-between;
                                              font-size: 14px;
                                              font-weight: 500;
                                              line-height: 22.04px;

                                              ${down("md")} {
                                                        font-weight: 600;
                                              }
                                      }

                                      .nav_link.active {
                                              color: #099819;
                                      }
                            }
                    }
          }
  }

  .navbar_content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          . {
                    ${up("md")} {
                            display: none !important;
                            visibility: hidden;
                    }

                    display: flex;
                    align-items: center;
                    column-gap: 1rem;
                    cursor: pointer;
                    visibility: visible;

                    button {
                            font-size: 14px;
                            font-weight: 600;
                            text-align: center;
                            padding: 4px 5px;
                            column-gap: 1px;
                    }
          }

          .home_nav_links {
                    // ${down("md")} {
                    //     display: none;
                    //     visibility: hidden;
                    // }

                    ul {
                            display: flex;
                            align-items: center;
                            column-gap: 35px;
                            visibility: visible;

                            ${down("lg")} {
                                      column-gap: 25px;
                            }

                            ${down("sm")} {
                                      column-gap: 15px !important;
                            }

                            li {
                                      padding: 10px 0px 10px 0px;

                                      .anchor-tag {
                                              background-color: #ffa531;
                                              color: white;
                                              border-radius: 4000px;
                                              width: 1rem;
                                              height: 1rem;
                                              font-size: 10px;
                                              font-weight: 700;
                                              top: 0;
                                              position: absolute;
                                              display: inline-flex;
                                              align-items: center;
                                              justify-content: center;
                                              inset-inline-end: -0.5rem;
                                      }

                                      .nav-link,
                                      a,
                                      button {
                                              font-size: 14px;
                                              font-weight: 500;
                                              color: white;

                                              svg {
                                                        width: 20px;
                                                        height: 20px;
                                              }

                                              ${down("md")} {
                                                        font-size: 15px;
                                              }
                                      }

                                      a.active {
                                              color: #099819;
                                      }

                                      --bs-nav-link-color: #262626;
                                      --bs-nav-link-hover-color: #098016;
                            }
                    }
          }

          .agrogid_brand {
                    max-width: 126px;
                    //margin: auto;
                    //flex: 1 1 auto;

                    ${down("md")} {
                            margin: 0;
                            max-width: 90px;
                    }

                    img {
                            width: 100%;
                            min-width: 86px;
                    }
          }
  }

  .contact-menu {
          position: relative;
          display: inline-flex;
  }

  .contact-menu__dropdown {
          position: absolute;
          top: 120%;
          right: 0;
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 10px;
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
          padding: 8px;
          display: flex;
          flex-direction: column;
          gap: 6px;
          z-index: 10005;
          min-width: 160px;
  }

  .contact-menu__dropdown button {
          background: transparent;
          border: none;
          text-align: left;
          font-size: 14px;
          font-weight: 600;
          color: #2b2b2b;
          padding: 8px 10px;
          border-radius: 8px;
          cursor: pointer;
  }

  .contact-menu__dropdown button:hover {
          background: rgba(11, 156, 7, 0.12);
  }

  .contact-menu__dropdown--floating {
          position: fixed;
          bottom: calc(10% + 64px);
          right: 50px;
  }

  ${down("md")} {
          .contact-menu__dropdown--floating {
                    right: 30px;
          }
  }

  &.product-navigation {
          background: #fff;

          nav.navbar {
                    min-height: 80px;
                    padding: 0;
                    background: #fff !important;

                    ${up("md")} {
                            padding: 0;
                            margin: 0;
                    }
          }

          .navbar_content {
                    position: relative;
                    display: grid;
                    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
                    width: min(100% - 48px, 1280px);
                    min-height: 80px;
                    margin: 0 auto;
          }

          .agrogid_brand {
                    max-width: 126px;
                    margin: 0;
                    flex: 0 0 auto;

                    img { min-width: 0; }
          }

          .product-nav-links {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: clamp(16px, 2vw, 28px);

                    a {
                            color: #67746d;
                            font-family: Halenoir, sans-serif;
                            font-size: 14px;
                            font-weight: 500;
                            text-decoration: none;

                            &:hover,
                            &.active { color: var(--color-primary); }
                    }
          }

          .home_nav_links {
                    justify-self: end;

          ul {
                    column-gap: 9px;

                    li {
                            padding: 0;

                            .nav_link,
                            a,
                            button {
                                      display: inline-flex;
                                      align-items: center;
                                      justify-content: center;
                                      width: 42px;
                                      height: 42px;
                                      border: 0 !important;
                                      border-radius: 50%;
                                      padding: 0 !important;
                                      background: #fff !important;
                                      color: #173e29 !important;

                                      &:hover { background: #edf8ee !important; color: var(--color-primary) !important; }
                            }

                            .anchor-tag {
                                      top: -5px;
                                      inset-inline-end: -5px;
                                      width: 17px;
                                      height: 17px;
                                      background: var(--color-secondary);
                                      color: #fff;
                            }
                    }
          }
          }

          .avatar {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 8px;
                    background: #eaf6eb;
                    color: #087e18;
                    font-size: 11px;
                    font-weight: 800;
          }

          .search-input-container {
                    top: calc(100% - 4px) !important;
                    width: min(100% - 32px, 500px) !important;
          }

          @media (max-width: 767px) {
                    nav.navbar, .navbar_content { min-height: 70px; }
                    .navbar_content {
                            display: grid;
                            grid-template-columns: auto minmax(0, 1fr) auto;
                            width: min(100% - 32px, 560px);
                    }
                    .agrogid_brand { max-width: 104px; }
                    .product-nav-links { display: none; }
                    .home_nav_links {
                            width: auto;
                            margin-left: auto;

                            ul {
                                      margin: 0;
                                      padding: 0;
                                      column-gap: 6px;
                            }
                    }
                    .home_nav_links ul li .nav_link, .home_nav_links ul li a, .home_nav_links ul li button { width: 38px; height: 38px; }
          }
  }
`;
export const HomeNavWrapper = styled.div`
  background: transparent;
  padding: 0;
  width: 100%;
  max-width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;

  nav.navbar {
          position: relative;
          background: #f1f1f1f2 !important;
          /* box-shadow: 2px 3px 9px 4px #eaeaea; */
          padding: 1.2rem 0.9rem;
          border-radius: 16px;

          ${up("md")} {
                    ${"" /* width: 87%; */}
                    padding-left: 7%;
                    padding-right: 7%;
                    margin-left: auto;
                    margin-right: auto;
          }

          .menu_links {
                    ${up("md")} {
                            display: none;
                    }

                    display: block;
                    position: absolute;
                    background-color: #f1f1f1e5;
                    height: 200px;
                    z-index: -1;
                    top: 120%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100%;
                    border-radius: 12px;
                    padding: 1rem;
                    max-height: 50vh;
                    overflow: auto;

                    ul {
                            & > :not([hidden]) ~ :not([hidden]) {
                                      --tw-divide-y-reverse: 0;
                                      border-top-width: calc(
                                              1px *
                                                        calc(
                                                                1 -
                                                                          var(
                                                                                  --tw-divide-y-reverse
                                                                          )
                                                        )
                                      );
                                      border-bottom-width: calc(
                                              1px *
                                                        var(
                                                                --tw-divide-y-reverse
                                                        )
                                      );
                                      border-color: #cac8c8;
                            }

                            li {
                                      padding: 8px 0px;

                                      .nav_link,
                                      a {
                                              display: flex;
                                              align-items: center;
                                              justify-content: space-between;
                                              font-size: 14px;
                                              font-weight: 500;
                                              line-height: 22.04px;

                                              ${down("md")} {
                                                        font-weight: 600;
                                              }
                                      }

                                      .nav_link.active {
                                              color: #099819;
                                      }
                            }
                    }
          }
  }

  .navbar_content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          button {
          }

          .md_home_nav_links {
                    ${up("md")} {
                            display: none !important;
                            visibility: hidden;
                    }

                    display: flex;
                    align-items: center;
                    column-gap: 1rem;
                    cursor: pointer;
                    visibility: visible;

                    button {
                            font-size: 14px;
                            font-weight: 500;
                            text-align: left !important;
                            padding: 4px 5px;
                            column-gap: 1px;
                    }
          }

          .home_nav_links {
                    ${down("md")} {
                            display: none;
                            visibility: hidden;
                    }

                    ul {
                            display: flex;
                            align-items: center;
                            column-gap: 35px;
                            visibility: visible;

                            ${down("lg")} {
                                      column-gap: 10px;
                            }

                            li {
                                      padding: 10px 0px 10px 0px;

                                      .nav-link,
                                      a {
                                              font-size: 14px;
                                              font-weight: 500;
                                              text-wrap: nowrap;

                                              ${down("md")} {
                                                        font-size: 15px;
                                              }
                                      }

                                      a.active {
                                              color: #099819;
                                      }

                                      --bs-nav-link-color: #262626;
                                      --bs-nav-link-hover-color: #098016;
                            }
                    }
          }

          .agrogid_brand {
                    max-width: 143.64px;
                    margin: auto;
                    flex: 1 1 auto;

                    ${down("md")} {
                            margin: 0;
                            max-width: 90px;
                    }

                    img {
                            width: 100%;
                    }
          }
  }

  .contact-menu {
          position: relative;
          display: inline-flex;
  }

  .contact-menu__dropdown {
          position: absolute;
          top: 120%;
          right: 0;
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 10px;
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
          padding: 8px;
          display: flex;
          flex-direction: column;
          gap: 6px;
          z-index: 10005;
          min-width: 190px;
  }

  .contact-menu__dropdown button {
          background: transparent;
          border: none;
          text-align: left;
          font-size: 14px;
          font-weight: 600;
          color: #2b2b2b;
          padding: 8px 10px;
          border-radius: 8px;
          cursor: pointer;
  }

  .contact-menu__dropdown button:hover {
          background: rgba(11, 156, 7, 0.12);
  }

  &.landing-home-navigation {
          position: fixed;
          top: 0;
          right: 0;
          left: 0;
          z-index: 1030;
          background: #fff;

          &.market-prices-navigation {
                    position: fixed;
                    top: 0;
                    right: 0;
                    left: 0;
          }

          .market-ticker {
                    display: flex;
                    align-items: center;
                    min-height: 36px;
                    padding-left: clamp(16px, 3vw, 42px);
                    background: #1e2521;
                    color: #a7aea9;
                    font-family: Halenoir, sans-serif;
          }

          .ticker-label {
                    display: inline-flex;
                    flex: 0 0 auto;
                    align-items: center;
                    gap: 7px;
                    padding-right: 22px;
                    color: #f6f7f6;
                    font-size: 12px;
                    font-weight: 600;
                    white-space: nowrap;

                    svg { width: 15px; height: 15px; color: #22b735; strokeWidth: 2.4px; }
          }

          .ticker-viewport {
                    min-width: 0;
                    flex: 1;
                    overflow: hidden;
          }

          .market-ticker-content {
                    display: flex;
                    width: max-content;
                    align-items: center;
                    gap: 28px;
                    white-space: nowrap;
                    animation: ticker-scroll 120s linear infinite;
          }

          .ticker-viewport:hover .market-ticker-content {
                    animation-play-state: paused;
          }

          .ticker-item {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 11px;
                    font-weight: 600;

                    .ticker-emoji { font-style: normal; font-size: 14px; line-height: 1; }

                    strong { color: #f7f7f7; font-weight: 800; }
                    small { margin-left: 1px; color: #b9c0bb; font-size: 7px; font-weight: 500; }
                    b { font-size: 10px; font-weight: 700; }
                    b.up { color: #12b230; }
                    b.down { color: #fa4f4f; }
          }

          .ticker-price-list {
                    flex: 0 0 auto;
                    padding: 0 clamp(16px, 3vw, 42px) 0 18px;
                    background: #1e2521;
                    color: #22b435;
                    font-size: 11px;
                    font-weight: 900;
                    text-decoration: underline;
                    text-underline-offset: 3px;
          }

          .landing-navbar {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    min-height: 80px;
                    width: min(100% - 48px, 1280px);
                    margin: 0 auto;
          }

          .landing-brand { display: inline-flex; flex: 0 0 auto; width: 126px; 
                ${down("md")}{
                        width: 100px;
                }
        }
          .landing-brand img { width: 100%; }
          .landing-nav-links, .landing-nav-actions { display: flex; align-items: center; }
          .landing-nav-links { justify-content: center; gap: clamp(16px, 2vw, 28px); }
          .landing-nav-links a { color: #67746d; font-family: Halenoir, sans-serif; font-size: 14px; font-weight: 500; text-decoration: none; }
          .landing-nav-links a:hover,
          .landing-nav-links a.active { color: var(--color-primary); }
          .landing-nav-actions { gap: 8px; }
          .landing-nav-actions a { display: inline-flex; align-items: center; gap: 4px; border-radius: 999px; padding: 10px 13px; background: var(--color-secondary); color: #fff; font-family: Halenoir, sans-serif; font-size: 13px; font-weight: 800; text-decoration: none; }
          .landing-nav-actions a:last-child { background: #089e19; }
          .landing-nav-actions svg { width: 14px; height: 14px; strokeWidth: 1.7px; }
          .landing-menu-toggle, .landing-mobile-menu { display: none; }

          .support-menu {
                    position: fixed;
                    right: 50px;
                    bottom: 10%;
                    z-index: 5;
          }

          .support-menu {
            position: fixed;
            bottom: 10%;
            right: 50px;
            z-index: 10000;
          }

          .support-menu .support {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            background: var(--color-primary);
            border: none;
            outline: none;
            padding: 0px;

            &:hover {
              background: var(--color-primary-dark);
            }

            svg {
              width: 33.75px;
              height: 33.75px;

              path {
                strokeWidth: 2px;
              }
            }
          }

          ${down("md")} {
            .support-menu {
              right: 30px;
            }
          }
          @keyframes ticker-scroll {
                    from { transform: translateX(0); }
                    to { transform: translateX(-50%); }
          }

          @media (max-width: 900px) {
                    .landing-navbar { width: min(100% - 32px, 720px); min-height: 70px; }
                    .landing-nav-links, .landing-nav-actions { display: none; }
                    .landing-menu-toggle {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            width: 42px;
                            height: 42px;
                            border: 0;
                            border-radius: 10px;
                            background: transparent;
                            color: #173e29;

                            &:hover {
                                      background: #edf8ee;
                                      color: var(--color-primary);
                            }

                            svg { width: 22px; height: 22px; }
                    }

                    .landing-mobile-menu {
                            position: absolute;
                            top: calc(100% - 2px);
                            right: 0;
                            left: auto;
                            z-index: 5;
                            display: block;
                            width: 100%;
                            max-height: calc(100vh - 118px);
                            overflow: auto;
                            padding: 14px;
                            border: 1px solid #e4ece6;
                            border-radius: 16px 16px;
                            background: rgb(255 255 255 / 81%);
                            box-shadow: 0 24px 45px rgb(17 44 28 / 16%);
                            transform-origin: top center;
                            backdrop-filter: blur(8px);
                    }

                    .mobile-menu-label {
                            display: block;
                            margin: 0 10px 10px;
                            color: #8a978e;
                            font-family: Halenoir, sans-serif;
                            font-size: 10px;
                            font-weight: 700;
                            letter-spacing: .12em;
                            text-transform: uppercase;
                    }

                    .mobile-menu-links {
                    border-bottom: 1px solid #edf1ee;
                    span + span { border-top: 1px solid #edf1ee; }
                    }

                    .landing-mobile-menu .mobile-nav-link {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            min-height: 30px;
                            padding: 8px 9px;
                            color: #263b2d;
                            font-family: Halenoir, sans-serif;
                            font-size: 14px;
                            font-weight: 600;
                            text-decoration: none;
                            border-bottom: 1px solid #dadada57;
                            svg {
                                      width: 17px;
                                      height: 17px;
                                      color: #75a27b;
                                      transition: transform 160ms ease, color 160ms ease;
                            }

                            &:hover {
                                      color: #087e18;

                                      svg {
                                              color: #087e18;
                                              transform: translate(2px, -2px);
                                      }
                            }
                    }

                    .mobile-action-links {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            margin-top: 12px;
                    }

                    .landing-mobile-menu .mobile-business-link,
                    .landing-mobile-menu .mobile-household-link {
                            display: inline-flex;
                            align-items: center;
                            gap: 5px;
                            min-height: 26px;
                            border-radius: 999px;
                            padding: 8px 13px;
                            color: #fff;
                            font-family: Halenoir, sans-serif;
                            font-size: 12px;
                            font-weight: 700;
                            text-decoration: none;
                    }

                    .landing-mobile-menu .mobile-business-link {
                            background: var(--color-secondary);
                    }

                    .landing-mobile-menu .mobile-household-link {
                            background: var(--color-primary);
                    }
                    .ticker-price-list { padding-right: 16px; }
                    .support-menu { right: 30px; }
          }

          @media (max-width: 520px) {
                    .market-ticker { min-height: 34px; padding-left: 12px; }
                    .ticker-label { padding-right: 14px; font-size: 10px; }
                    .ticker-label svg { width: 13px; height: 13px; }
                    .market-ticker-content { gap: 20px; animation-duration: 200s; }
                    .ticker-item { font-size: 10px; }
                    .ticker-price-list { padding-left: 12px; font-size: 9px; }
          }
  }

  &.landing-home-navigation ~ main {
          padding-top: 116px;
  }

  @media (max-width: 767px) {
          &.landing-home-navigation ~ main {
                    padding-top: 104px;
          }
  }
`;
